import { ProductRequestsPage } from './ProductRequestsPage';

export const ProductRequestsPageClient = () => {
	return <ProductRequestsPage />;
};
